module.exports = __webpack_public_path__ + "img/sign-up-with-linkedin.1f22a25b.png";